import { ANCHOR_TYPES } from '.';

export const handleAnchorPropsByType = (type: ANCHOR_TYPES, href: string) => {
  switch (type) {
    case ANCHOR_TYPES.callTelephone:
      return {
        href: `tel:${href}`,
      };
    case ANCHOR_TYPES.openInNewTab:
      return {
        href,
        target: '_blank',
        rel: 'noopener noreferrer',
      };
    default:
      return {};
  }
};
